import React from "react"
import { TextField } from "@material-ui/core"
import useStyles from "@/popups/components/TextArea/styles"

export type TextAreaProps = {
	value: string
	onChange: (value: string) => void
	placeholder?: string
	minHeight?: number
}

export const TextArea: React.FC<TextAreaProps> = ({
	value,
	onChange,
	placeholder = "Descreva aqui...",
	minHeight = 80
}) => {
	const classes = useStyles({ minHeight })

	return (
		<TextField
			multiline
			fullWidth
			variant="outlined"
			size="small"
			value={value}
			onChange={(event) => onChange(event.target.value)}
			placeholder={placeholder}
			className={classes.root}
		/>
	)
}
